import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
    selector: '[appSimplifiedFormField]',
    standalone: false
})
export class SimplifiedFormFieldDirective {
  @Input('appSimplifiedFormField')
  set appSimplifiedFormField(activated: boolean) {
    if (activated) {
      this.elementRef.nativeElement.classList.add('mat-simplified-form-field');
    } else {
      this.elementRef.nativeElement.classList.remove('mat-simplified-form-field');
    }
  }

  constructor(private elementRef: ElementRef) {
  }
}
